// extracted by mini-css-extract-plugin
export default {"link":"pageLanguageLink_link__C5QMS","icon":"pageLanguageLink_icon__HIfLu"};